<template>
  <div class="preika-auth-page">
    <section class="preika-error-panel">
      <img
        src="/img/avatars/preika_black.png"
        :alt="productName"
        class="preika-error-panel__logo"
      >
      <span class="preika-error-panel__icon">
        <CIcon name="cil-lock-locked"/>
      </span>
      <p class="preika-error-panel__eyebrow">ACCESS DENIED</p>
      <!--
        **開けない理由で、書き分ける**（2026-09-22）。
        理由ごとに次にすることと頼む相手が違う。同じ文言だと、プランが足りないのに
        権限を頼んだり、通信の失敗を権限の問題と思い込んだりする。
      -->
      <h1>{{ message.title }}</h1>
      <p>{{ message.body }}</p>
      <div class="preika-error-panel__actions">
        <router-link to="/dashboard" class="btn btn-primary">
          ダッシュボードへ戻る
          <CIcon name="cil-arrow-right"/>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { PRODUCT_NAME } from '@/common/productName'

/*
 * 文言は Gemini に「読んだ人が、なぜ開けないかと次に何をすればよいかが分かるか」を
 * 確かめたもの（2026-09-22）。社内の仕組みの名前は出さない。
 */
export const MESSAGES = {
  FEATURE: {
    title: 'この画面は現在のご契約では利用できません',
    body: '現在のご契約や設定では、この画面の機能は有効になっていません。利用をご希望の場合は、社内の管理者にご相談ください。'
  },
  PROVIDER: {
    title: 'この画面は運営担当者専用です',
    body: 'この画面はサービスの運営担当者専用のため、現在のアカウントでは利用できません。'
  },
  ROLE: {
    title: 'この画面を開く権限がありません',
    body: '現在のアカウントには、この画面を開く権限が設定されていません。利用をご希望の場合は、社内の管理者に権限の追加をご相談ください。' +
      '追加された後は、一度ログアウトして再ログインすると開けるようになります。'
  },
  UNKNOWN: {
    title: '権限の情報を確認できませんでした',
    body: '通信エラーなどにより、情報を正しく読み込めなかった可能性があります。時間をおいてから再度お試しください。' +
      '何度もエラーが続く場合は、社内の管理者にご相談ください。'
  }
}

export default {
  name: 'AccessDenied',

  computed: {
    /** 売るときの正式な表記。**1か所から取る。** */
    productName () {
      return PRODUCT_NAME
    },
    /**
     * 理由は router の案内（accessContextGuard）が query.reason で渡す。
     * 'FEATURE'＝会社でその機能が有効でない、'PROVIDER'＝運営専用の画面、'ROLE' または無し＝権限が無い、
     * それ以外（通信の失敗などの符号）＝開けるか確かめられなかった。
     *
     * 'PUBLIC_ROUTE_REFERENCE_FORBIDDEN'＝詳細の URL を、サーバが「その人には見せない」と断った
     * （自分宛てでない書類の詳細を直接開いた、など）。確かめられなかったのではなく断られたので、
     * 権限が無いときと同じ文を出す。「通信エラーなど…時間をおいて」と出すと、待っても開けない。
     */
    message () {
      const reason = this.$route && this.$route.query ? this.$route.query.reason : ''
      if (reason === 'FEATURE') return MESSAGES.FEATURE
      if (reason === 'PROVIDER') return MESSAGES.PROVIDER
      if (!reason || reason === 'ROLE' || reason === 'PUBLIC_ROUTE_REFERENCE_FORBIDDEN') return MESSAGES.ROLE
      return MESSAGES.UNKNOWN
    }
  },
}
</script>

<style scoped>
.preika-error-panel {
  position: relative;
  z-index: 1;
  width: min(100%, 650px);
  padding: 52px;
  border: 1px solid rgba(255, 255, 255, .85);
  border-radius: 25px;
  background: rgba(255, 255, 255, .96);
  box-shadow: 0 30px 80px rgba(7, 52, 87, .17);
  text-align: center;
}

.preika-error-panel__logo {
  width: 150px;
  max-height: 48px;
  margin-bottom: 25px;
  object-fit: contain;
}

.preika-error-panel__icon {
  display: inline-flex;
  width: 70px;
  height: 70px;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 23px;
  background: rgba(224, 145, 29, .12);
  color: #a76108;
  font-size: 34px;
}

.preika-error-panel__eyebrow {
  margin: 10px 0 0 !important;
  color: #a76108 !important;
  font-size: 12px !important;
  font-weight: 900;
  letter-spacing: .15em;
}

.preika-error-panel h1 {
  margin: 12px 0;
  color: var(--preika-navy-900);
  font-size: 24px;
  line-height: 1.5;
}

.preika-error-panel p {
  max-width: 520px;
  margin: 0 auto;
  color: var(--preika-text-muted);
  font-size: 12px;
  line-height: 1.9;
}

.preika-error-panel__actions {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

@media (max-width: 575.98px) {
  .preika-error-panel {
    padding: 38px 23px;
  }

  .preika-error-panel h1 {
    font-size: 20px;
  }
}
</style>
